import Config from '../../common/model/Config';

import logo_pass        from '../../common/resource/img/logo_pass.png';
import logo_payco       from '../../common/resource/img/logo_payco.png';
import logo_kakao       from '../../common/resource/img/logo_kakao.png';
import logo_kakaopay    from '../../common/resource/img/logo_kakaopay.png';
import logo_kb          from '../../common/resource/img/logo_kb.png';
import logo_samsung     from '../../common/resource/img/logo_samsung.png';
import logo_naver       from '../../common/resource/img/logo_naver.png';
import logo_toss        from '../../common/resource/img/logo_toss.png';
import logo_shinhan     from '../../common/resource/img/logo_shinhan.png';
import logo_banksalad   from '../../common/resource/img/logo_banksalad.png';
import logo_hana        from '../../common/resource/img/logo_hana.png';
import logo_sample      from '../../common/resource/img/logo_sample.png';
import { providerChk }  from '../../common/utils/provider.id.check';
import { device }       from '../../common/utils/deviceCheck';

Array.prototype.shuffle = function () {
    var length = this.length;
    while (length) {
        var index = Math.floor((length--) * Math.random());
        var temp = this[length];
        this[length] = this[index];
        this[index] = temp;
    }
    return this;
};

export const process = {
    providerService: (res) => {
        var resultArr = [];
        var providerArr = [];
        var res = res.shuffle();

        const mode = Config.provider.mode.id; //dev, prod
        const typeId = Config.provider.type.id; //gov, ent

        //공공,민간,개발,운영 중 해당하는 List로 정련
        res.forEach((d,i)=>{
            if(device.checkMobileType() == "IOS"){
                if(providerChk.isSamsung(d.provider_id)){
                    return;
                }
            }
            // Config Auth의 설정한 개발, 운영과 공공, 민간에 일치하지 않는 인증기관 제외
            if(d.provider_type != typeId || d.oper_sort != mode){ 
                return;
            }
                    
            if (d.status_code === 'n' && d.unuse_style === 'hide') {
                return
            }
            if (d.status_code === 'n' && !!!d.unuse_style) {
                return
            }
            // Config Auth의 unUseList 옵션의 인증기관 제외
            if(!unUseProviderCheck(d.provider_id)){
                return;
            }

            var provider = process.createData(d);
            resultArr.push(provider);
        });

        return resultArr;
    },
    createData: (d) => {
        const providerJson = {
            providerLabel: "",
            providerId: "",
            providerName: "",
            providerLogo: "",
            unuse_style: d.unuse_style,
            status_code: d.status_code.trim()
        }
        
        if(providerChk.isPass(d.provider_id)){
            providerJson.providerId = d.provider_id;
            providerJson.providerName = "통신사패스";
            providerJson.providerLabel='통신사패스<br><span>(SKT, KT, LGU+)</span>';
            providerJson.providerLogo = logo_pass;
        }else if(providerChk.isKakao(d.provider_id)){
            providerJson.providerId = d.provider_id;
            providerJson.providerName = "카카오톡"
            providerJson.providerLabel='카카오톡'
            providerJson.providerLogo = logo_kakao;
        }else if(providerChk.isKakaoPay(d.provider_id)){
            providerJson.providerId = d.provider_id;
            providerJson.providerName = "카카오페이"
            providerJson.providerLabel='카카오페이'
            providerJson.providerLogo = logo_kakaopay;
        }else if(providerChk.isPayco( d.provider_id)){
            providerJson.providerId = d.provider_id;
            providerJson.providerName = "페이코"
            providerJson.providerLabel='페이코'
            providerJson.providerLogo = logo_payco;
        }else if(providerChk.isSamsung(d.provider_id)){
            providerJson.providerId = d.provider_id;
            providerJson.providerName = "삼성패스"
            providerJson.providerLabel='삼성패스'
            providerJson.providerLogo = logo_samsung;
        }else if(providerChk.isKb(d.provider_id)){
            providerJson.providerId = d.provider_id;
            providerJson.providerName = "KB모바일"
            providerJson.providerLabel='KB모바일<br>인증서'
            providerJson.providerLogo = logo_kb;
        }else if(providerChk.isToss(d.provider_id)){
            providerJson.providerId = d.provider_id;
            providerJson.providerName = "토스"
            providerJson.providerLabel='토스'
            providerJson.providerLogo = logo_toss;
        }else if(providerChk.isNaver(d.provider_id)){
            providerJson.providerId = d.provider_id;
            providerJson.providerName = "네이버"
            providerJson.providerLabel='네이버'
            providerJson.providerLogo = logo_naver;
        }else if(providerChk.isShinhan(d.provider_id)){
            providerJson.providerId = d.provider_id;
            providerJson.providerName = "신한"
            providerJson.providerLabel='신한인증서'
            providerJson.providerLogo = logo_shinhan;
        }else if(providerChk.isBanksalad(d.provider_id)){
            providerJson.providerId = d.provider_id;
            providerJson.providerName = "뱅크샐러드"
            providerJson.providerLabel='뱅크샐러드'
            providerJson.providerLogo = logo_banksalad;
        }else if(providerChk.isHana(d.provider_id)){
            providerJson.providerId = d.provider_id;
            providerJson.providerName = "하나"
            providerJson.providerLabel='하나인증서'
            providerJson.providerLogo = logo_hana;
        }else{
            providerJson.providerId = d.provider_id;
            providerJson.providerName = d.name;
            providerJson.providerLabel= d.name;
            providerJson.providerLogo = logo_sample;
        }
        return providerJson;
    }
}


/**
 * Config의 Provider Un Use 항목 체크
 * 제외 항목이 있을 시 false를 반환
 */
function unUseProviderCheck(providerId){
    const unUseProviderIdList = Config.provider.unUseIdList;
    if(unUseProviderIdList.length == 0){
        return true;
    }
    if(unUseProviderIdList.indexOf(providerId) != -1 ){
        return false;
    }
    return true;
}